document.addEventListener('DOMContentLoaded', function() {
    // Smooth scroll animations for about us sections
    const observeElements = () => {
        const elements = document.querySelectorAll('.about-text-section, .about-image-text, .about-stats-section, .about-team-section, .about-values-section');
        
        if (elements.length === 0) return;

        const observer = new IntersectionObserver((entries) => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    entry.target.style.opacity = '1';
                    entry.target.style.transform = 'translateY(0)';
                }
            });
        }, {
            threshold: 0.1,
            rootMargin: '0px 0px -50px 0px'
        });

        elements.forEach(element => {
            element.style.opacity = '0';
            element.style.transform = 'translateY(20px)';
            element.style.transition = 'opacity 0.6s ease, transform 0.6s ease';
            observer.observe(element);
        });
    };

    // Counter animation for statistics
    const animateCounters = () => {
        const counters = document.querySelectorAll('.about-stat-number');
        
        counters.forEach(counter => {
            const target = counter.textContent;
            const numericValue = parseInt(target.replace(/[^\d]/g, ''));
            
            if (isNaN(numericValue)) return;
            
            const observer = new IntersectionObserver((entries) => {
                entries.forEach(entry => {
                    if (entry.isIntersecting) {
                        animateCounter(counter, numericValue, target);
                        observer.unobserve(entry.target);
                    }
                });
            }, { threshold: 0.5 });
            
            observer.observe(counter);
        });
    };

    const animateCounter = (element, targetNum, originalText) => {
        let current = 0;
        const increment = targetNum / 50;
        const timer = setInterval(() => {
            current += increment;
            if (current >= targetNum) {
                element.textContent = originalText;
                clearInterval(timer);
            } else {
                const suffix = originalText.replace(/[\d,]/g, '');
                element.textContent = Math.floor(current).toLocaleString() + suffix;
            }
        }, 40);
    };

    // Parallax effect for hero section
    const setupParallax = () => {
        const hero = document.querySelector('.about-hero');
        if (!hero) return;

        const handleScroll = () => {
            const scrolled = window.pageYOffset;
            const rate = scrolled * -0.5;
            hero.style.transform = `translateY(${rate}px)`;
        };

        // Only apply parallax on desktop
        if (window.innerWidth > 768) {
            window.addEventListener('scroll', handleScroll);
        }

        // Remove parallax on resize if mobile
        window.addEventListener('resize', () => {
            if (window.innerWidth <= 768) {
                window.removeEventListener('scroll', handleScroll);
                hero.style.transform = 'none';
            } else {
                window.addEventListener('scroll', handleScroll);
            }
        });
    };

    // Hover effects for interactive elements
    const setupHoverEffects = () => {
        const cards = document.querySelectorAll('.about-team-member, .about-value-item');
        
        cards.forEach(card => {
            card.addEventListener('mouseenter', function() {
                this.style.transform = 'translateY(-8px) scale(1.02)';
            });
            
            card.addEventListener('mouseleave', function() {
                this.style.transform = 'translateY(0) scale(1)';
            });
        });
    };

    // Smooth scrolling for anchor links (if any are added)
    const setupSmoothScroll = () => {
        const links = document.querySelectorAll('a[href^="#"]');
        
        links.forEach(link => {
            link.addEventListener('click', function(e) {
                e.preventDefault();
                const targetId = this.getAttribute('href');
                const targetElement = document.querySelector(targetId);
                
                if (targetElement) {
                    targetElement.scrollIntoView({
                        behavior: 'smooth',
                        block: 'start'
                    });
                }
            });
        });
    };

    // Initialize all functions
    observeElements();
    animateCounters();
    setupParallax();
    setupHoverEffects();
    setupSmoothScroll();

    // Add loading animation
    document.querySelector('.about-us-section').style.opacity = '0';
    setTimeout(() => {
        document.querySelector('.about-us-section').style.opacity = '1';
        document.querySelector('.about-us-section').style.transition = 'opacity 0.5s ease';
    }, 100);
});